import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ResourceTypeDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class ResourceTypeService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getMachineTypes = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ResourceTypeDto[]>({
      method: 'GET',
      url: '/api/app/resource-type/machine-types',
    },
    { apiName: this.apiName,...config });
}